import { URL_PATH } from './constants';

/** Strip leading slash for nested routes under `/control-plane`. */
export const toControlPlaneChildPath = (path: string): string => {
  if (path === '/') {
    return '';
  }
  if (path.startsWith(`${URL_PATH.CONTROL_PLANE}/`)) {
    return path.slice(URL_PATH.CONTROL_PLANE.length + 1);
  }
  return path.replace(/^\//, '');
};
